// @ts-check
import { map } from "lodash";
import { nanoid } from "nanoid";
import {
  findGroupTypes,
  isDemandGroup,
  isLineOfBusiness,
} from "src/util/customerConfig";
import {
  getIndirectForecastFlg,
  getIndirectForecastTargetFlg,
} from "src/allocation/util/allocationProject";
import { FORECAST } from "../pageModes";
import { DEFAULT_VIEW_MODE, CURRENT_GROUP_ONLY_VIEW } from "../viewModes";
import { selectQuery } from "./selectQuery";

export default ({
  group,
  workspace,
  pageMode,
  viewMode,
  referenceDate,
  prefillDate,
  prefillOption,
  orgStructurePITOption,
  orgStructurePITDate,
  hideHiddenTeams,
}) => {
  const { groupTypes, allocation, featureFlags } = workspace.config;
  const {
    enableFinancialForecasting,
    showAllBudgetTargetGroups,
    enablePlannerBudgetTarget,
    enablePlannerTargets,
  } = allocation;
  const { enableForecastCurrentGroupOnlyMode } = featureFlags;
  const isRequestorGroup = isDemandGroup(groupTypes, group);
  const isLineOfBusinessGroup = isLineOfBusiness(groupTypes, group);
  const currentGroupOnly =
    enableForecastCurrentGroupOnlyMode && viewMode === CURRENT_GROUP_ONLY_VIEW;

  let enableTypedAllocations = false;

  // Only check the flag for forecast page
  if (pageMode === FORECAST) {
    if (isRequestorGroup) {
      enableTypedAllocations = getIndirectForecastFlg(groupTypes, group);
    } else {
      enableTypedAllocations = getIndirectForecastTargetFlg(groupTypes, group);
    }
  }

  const perspective =
    pageMode === FORECAST
      ? "FORECAST"
      : isRequestorGroup
        ? "PLANNER_REQUEST"
        : "PLANNER_APPROVE";

  const loadBudgetTargetGroups =
    enableFinancialForecasting && showAllBudgetTargetGroups;
  let budgetTargetGroupIds = [];
  if (loadBudgetTargetGroups && group.budgets) {
    budgetTargetGroupIds = map(group.budgets, (b) => b.targetGroupId);
  }

  const query = selectQuery(
    pageMode,
    viewMode || DEFAULT_VIEW_MODE,
    isRequestorGroup,
    isLineOfBusinessGroup
  );

  return {
    firstLoad: true,
    loading: true,
    backgroundRefresh: false,
    error: null,
    data: null,
    intersectingFteData: null,
    groupDiffData: null,
    queryPart1: query.part1,
    queryPart2: query.part2,
    variables: {
      refreshId: nanoid(),
      groupId: group.id,
      groupIdAsString: group.id,
      groupIdAsId: group.id,
      isRequestorGroup,
      isLineOfBusinessGroup,
      targetGroupTypes: map(
        findGroupTypes(workspace.config.groupTypes, "isDemand"),
        "id"
      ),
      roleAreaTypes: map(
        findGroupTypes(workspace.config.groupTypes, "isSupplyRoot"),
        "id"
      ),
      supplyGroupTypes: map(
        findGroupTypes(workspace.config.groupTypes, "isSupply"),
        "id"
      ),
      lineOfBusinessGroupTypes: map(
        findGroupTypes(workspace.config.groupTypes, "isLineOfBusiness"),
        "id"
      ),
      perspective,
      enableTypedAllocations,
      enableFinancialForecasting: !!enableFinancialForecasting,
      enablePlannerBudgetTarget: !!enablePlannerBudgetTarget,
      enablePlannerTargets: !!enablePlannerTargets,
      enableMemberCount: false,
      parentIds: group.parentIds,
      loadBudgetTargetGroups: !!loadBudgetTargetGroups,
      budgetTargetGroupIds,
      currentGroupOnly,
      referenceDate,
      includeReferenceDateHistoricGroups: !hideHiddenTeams,
      prefillDate,
      prefillOption,
      orgStructurePITOption,
      orgStructurePITDate,
    },
  };
};
